export default __webpack_public_path__ + "static/media/login.c60eb80d.png";